/**
 * The four platform roles and the content audiences they map to.
 *
 * The mapping is the backend's (`ContentControllerBase.viewerAudience`) and is
 * mirrored here for ONE purpose: choosing navigation and route guards. It is
 * never sent on a read — the API derives the viewer's pool from the token, and
 * `?audience=` can only narrow within it, never widen (§6.1).
 *
 * A client that sent its own audience would be asking to be trusted about the
 * one thing it must not be trusted about.
 */
export const PLATFORM_ROLES = ['PARENT', 'PRO', 'TSP', 'ORG_ADMIN'];
export const AUDIENCES = ['PARENT', 'PRO', 'TSP', 'ORG'];
/** Exhaustive by construction: a new role fails to compile until it is decided. */
export const AUDIENCE_FOR_ROLE = {
    PARENT: 'PARENT',
    PRO: 'PRO',
    TSP: 'TSP',
    ORG_ADMIN: 'ORG',
};
//# sourceMappingURL=audience.js.map